/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentTeamResponse } from './TournamentTeamResponse';
import {
    TournamentTeamResponseFromJSON,
    TournamentTeamResponseFromJSONTyped,
    TournamentTeamResponseToJSON,
    TournamentTeamResponseToJSONTyped,
} from './TournamentTeamResponse';

/**
 * Result of registering a team for a tournament
 * @export
 * @interface TeamRegistrationResultResponse
 */
export interface TeamRegistrationResultResponse {
    /**
     * 
     * @type {TournamentTeamResponse}
     * @memberof TeamRegistrationResultResponse
     */
    team: TournamentTeamResponse;
    /**
     * Whether payment is required to complete registration
     * @type {boolean}
     * @memberof TeamRegistrationResultResponse
     */
    requiresPayment: boolean;
    /**
     * Entry fee amount (0 if free)
     * @type {number}
     * @memberof TeamRegistrationResultResponse
     */
    entryFee: number;
}

/**
 * Check if a given object implements the TeamRegistrationResultResponse interface.
 */
export function instanceOfTeamRegistrationResultResponse(value: object): value is TeamRegistrationResultResponse {
    if (!('team' in value) || value['team'] === undefined) return false;
    if (!('requiresPayment' in value) || value['requiresPayment'] === undefined) return false;
    if (!('entryFee' in value) || value['entryFee'] === undefined) return false;
    return true;
}

export function TeamRegistrationResultResponseFromJSON(json: any): TeamRegistrationResultResponse {
    return TeamRegistrationResultResponseFromJSONTyped(json, false);
}

export function TeamRegistrationResultResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamRegistrationResultResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'team': TournamentTeamResponseFromJSON(json['team']),
        'requiresPayment': json['requiresPayment'],
        'entryFee': json['entryFee'],
    };
}

export function TeamRegistrationResultResponseToJSON(json: any): TeamRegistrationResultResponse {
    return TeamRegistrationResultResponseToJSONTyped(json, false);
}

export function TeamRegistrationResultResponseToJSONTyped(value?: TeamRegistrationResultResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': TournamentTeamResponseToJSON(value['team']),
        'requiresPayment': value['requiresPayment'],
        'entryFee': value['entryFee'],
    };
}

